export default __webpack_public_path__ + "static/media/rectangle_purple_cut_edge_mobile.61657f2e.svg";